import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { ModalMarkerComponent } from './modal-marker/modal-marker.component';
import { ModalQuestionComponent } from './modal-question/modal-question.component';
import { ModalComponent } from './modal/modal.component';
import { RouterModule } from '@angular/router';
import { QuestionComponent } from './question/question.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule
  ],
  exports: [
    ToolbarComponent,
    ModalMarkerComponent,
    ModalQuestionComponent,
    ModalComponent,
    QuestionComponent,
  ],
  declarations: [
    ToolbarComponent,
    ModalMarkerComponent,
    ModalQuestionComponent,
    ModalComponent,
    QuestionComponent,
  ]
})
export class SharedComponentsModule { }



// WEBPACK FOOTER //
// G:/Projekty/swaythegame/src/app/shared-components/shared-components.module.ts